/**
 * External dependencies
 */
 import inherits from 'inherits';

 export default class CurrentCloudBackup {
     constructor(cscom) {
         if (!(this instanceof CurrentCloudBackup)) {
             return new CurrentCloudBackup(cscom);
         }
         this.cscom = cscom;
     }
 
     get(data) {
         return this.cscom.req.get('/customer-site-api/cloud-backup/view', null, data);
     }
 
     list(data) {
         return this.cscom.req.get('/customer-site-api/cloud-backup/list', null, data);
     }

     updateBackupPassword(subscriptionId, backupPassword) {
        return this.cscom.req.post('/customer-site-api/subscriptions/' + subscriptionId + '/backup-password', null, {
            password: backupPassword
        });
     }
     
 }
 